// data source of poi
export const DATA_SOURCE_GOOGLE = '0';
export const DATA_SOURCE_FOURSQUARE = '1';
export const DATA_SOURCE_POI_BANK_NEXT = '3';
export const DATA_SOURCE_CUSTOM_POI = '4';

// transportation type
export const TRANSPORTATION_TYPE_DRIVING = '0';
export const TRANSPORTATION_TYPE_TRANSIT = '1';
export const TRANSPORTATION_TYPE_WALKING = '2';
export const TRANSPORTATION_TYPE_AIRPLANE = '8';
export const TRANSPORTATION_TYPE_TRANSIT_FROM_WEB = '3';
export const TRANSPORTATION_TYPE_DRIVING_FROM_WEB = '4';
export const TRANSPORTATION_TYPE_WALKING_FROM_WEB = '5';
export const TRANSPORTATION_TYPE_OSRM_DRIVING = '6';
export const TRANSPORTATION_TYPE_OSRM_WALKING = '7';

// status of api from funliday server
export const FUNLIDAY_REQUEST_STATUS_SUCCESS = '200';

// staus of api from poi bank
export const POI_BANK_NEXT_STATUS_SUCCESS = 1;
export const POI_BANK_NEXT_STATUS_REQUEST_FORMAT_ERROR = 2;
export const POI_BANK_NEXT_STATUS_INTERNAL_ERROR = 3;
export const POI_BANK_NEXT_STATUS_NO_RESULTS = 4;
export const POI_BANK_NEXT_STATUS_AUTH_FAIL = 5;
export const POI_BANK_NEXT_STATUS_QUERY_PROCESSING = 6;
export const POI_BANK_NEXT_STATUS_INVALID_CLIENT_ID = 101;
export const POI_BANK_NEXT_STATUS_INVALID_CODE_CHALLENGE = 102;
export const POI_BANK_NEXT_STATUS_MISSING_AUTH_CODE = 103;
export const POI_BANK_NEXT_STATUS_MISSING_CODE_VERIFIER = 104;
export const POI_BANK_NEXT_STATUS_INVALID_AUTH_CODE = 105;
export const POI_BANK_NEXT_STATUS_INVALID_CODE_VERIFIER = 106;
export const POI_BANK_NEXT_STATUS_SUCCESS_AUTH_CODE = 107;
export const POI_BANK_NEXT_STATUS_SUCCESS_ACCESS_TOKEN = 108;

// staus of api from poi bank
export const POI_BANK_NEXT_URL_TYPE_FACEBOOK = 11;
export const POI_BANK_NEXT_URL_TYPE_WEB_SITE = 15;
export const POI_BANK_NEXT_URL_TYPE_TWITTER = 18;
export const POI_BANK_NEXT_URL_TYPE_WIKI = 53;

// image data source for poi bank
export const PHTOT_TYPE_SYGIC = 1;
export const PHTOT_TYPE_POI_BANK = 2;

export const PHOTO_IMAGE_SIZE_MAIN = 600;
export const PHOTO_IMAGE_SIZE_THUMBNAIL = 100;

// journals
export const JOURNALS_STATUS_PRIVATE = 8;
